export class Option {
  constructor(
    public key?: string,
    public value?: string
  ) { }

  clone() {
    return new Option(
      this.key,
      this.value
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/option.ts